var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import moment from 'moment';
import { View } from 'react-native';
import { Placeholder } from './components';
import { Text } from '../Text';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet, formatMessage } from '../../utils';
import { User } from '../User';
import { Focusable } from '../Focusable';
import { Checkbox } from '../Checkbox';
import { Counter } from '../Counter';
export const Conversation = (_a) => {
    var { style, fluid } = _a, props = __rest(_a, ["style", "fluid"]);
    const styles = useStyleSheet(getStyles);
    if (props.isLoading)
        return React.createElement(Placeholder, { fluid: fluid, style: style });
    const { participant, lastMessage, unseen, disabled, onPress, isEditing, isSelected, onSelect, lastMessageStyle } = props;
    const isSeen = !unseen || (isEditing && !isSelected);
    return (React.createElement(Focusable, Object.assign({ style: [styles.container, fluid ? styles.fluid : null, style], hoverStyle: isEditing ? {} : styles.hover, disabled: !!disabled || isEditing, onPress: onPress }, (isEditing ? { disabledStyle: {} } : {})),
        isEditing && (React.createElement(Checkbox, { checked: !!isSelected, onChange: onSelect, style: styles.checkbox })),
        React.createElement(User, { size: 'lg', name: participant.name, image: participant.image, type: participant.type, lastSeen: participant.lastActiveAt, online: participant.online }),
        React.createElement(View, { style: styles.main },
            React.createElement(View, { style: styles.row },
                React.createElement(View, { style: styles.nameWrapper },
                    React.createElement(Text, { type: 'body', size: 'lg', weight: 'semibold', style: [styles.name, isSeen ? styles.nameSeen : {}], numberOfLines: 1, ellipsizeMode: 'tail' }, participant.name)),
                unseen ? React.createElement(Counter, { value: unseen }) : null),
            React.createElement(View, { style: [styles.row, styles.rowBottom] },
                React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', numberOfLines: 1, ellipsizeMode: 'tail', style: [
                        styles.lastMessage,
                        isSeen ? styles.lastMessageSeen : {},
                        lastMessageStyle !== null && lastMessageStyle !== void 0 ? lastMessageStyle : {}
                    ] }, lastMessage ? formatMessage(lastMessage) : 'No messages yet'),
                lastMessage && (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.time }, moment(lastMessage.createdAt).calendar(null, {
                    sameDay: 'h:mm A',
                    lastDay: '[Yesterday]',
                    lastWeek: 'ddd',
                    sameElse: 'D MMM'
                })))))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        padding: size.G,
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: size.G
    },
    fluid: { flex: 1 },
    hover: { backgroundColor: color.invert2.p10 },
    checkbox: {
        marginRight: size.G
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    rowBottom: {
        marginTop: size.B
    },
    main: {
        flex: 1,
        justifyContent: 'space-between',
        marginLeft: size.G
    },
    nameWrapper: { flexDirection: 'row', flex: 1 },
    name: {
        marginRight: size.G,
        color: color.invert2.p100
    },
    nameSeen: {
        color: color.invert2.p68
    },
    lastMessage: {
        marginRight: size.G,
        color: color.invert2.p68
    },
    lastMessageSeen: {
        color: color.invert2.p56
    },
    time: {
        color: color.invert2.p42,
        flexShrink: 0
    }
}));
//# sourceMappingURL=index.js.map